import { render } from "./AuSwitchButton.vue?vue&type=template&id=20cc018d&scoped=true"
import script from "./AuSwitchButton.vue?vue&type=script&lang=js"
export * from "./AuSwitchButton.vue?vue&type=script&lang=js"

import "./AuSwitchButton.vue?vue&type=style&index=0&id=20cc018d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cc018d"]])

export default __exports__